import React,{Component} from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';

import TutorialBreifSummary from '../TutorialModel/Category/TutorialBreifSummary';
import './TutorialTile.css';

export default class TutorialTile extends Component
{

   /**
    *
    */
   constructor(props) {
    super(props);
    
    this.state = {
      TutorialBreifSummary: new TutorialBreifSummary(),
      isLoading: true,
      error: null
    };

  

   }


   render()
   {


      let TutorialBreifSummary = this.props.TutorialBreifSummary;
       if(!TutorialBreifSummary)
         {
           return( 
           <div className="tutorial-tile"  >
              <h2>Data not found</h2>
         </div>)
         }

     return(

            <div class="tutorial-card">
                   <div class="card-icon">
                      <img src={TutorialBreifSummary.icon} alt="Python Logo" />
                    </div>
                 <h3>{TutorialBreifSummary.title}</h3>
                 <p class="description">{TutorialBreifSummary.Icon}
                       {TutorialBreifSummary.description}
                  </p>
                 <p class="author"><i class="fa fa-user"></i> {TutorialBreifSummary.author}</p>
                    
                        <Link to={`${TutorialBreifSummary.redirectionUrl}`}>
                          <a className="read-more" >   Read More   </a>
                        </Link>
               </div>
   

     );

   }

  
}

